import React, { Component } from 'react'
import background  from '../Img/background.png'
import { Link } from 'react-router-dom'
import { Snackbar } from '@material-ui/core'
import Axios from 'axios'
import API from '../Utils/api';


const redirectUser = (perfil = 'CLIENTE') => {
    switch (perfil) {
        case 'CLIENTE':
            window.location.href = '/loja-cliente'
            break
        case 'CAMBISTA':
            window.location.href = '/receber-pedidos'
            break
        case 'GERENTE':
            window.location.href = '/gerente-bilhetes'
            break
        case 'SUBMASTER':
            this.props.history.push('/monitoria-clientes')
            break
        case 'ADMIN':
            this.props.history.push('/admin-gerenciar-gerentes')
            break
        case 'MASTER':
            this.props.history.push('/configuracoes')
    }
}

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            email: '',
            senha: '',
            auth: '',
            loggingIn: false,
            open: false,
            severity: 'danger',
            snackMessage: '',
            toggleExpand: false,
            parametros: '',
            route: '/',
            sac: "99999999999",
            banner: localStorage.getItem('banner')?  localStorage.getItem('banner') : ''
        }
        new Date().getHours() === localStorage.getItem('updateHour')? console.log('ok'): this.getBanner()
        this.getSAC();
        this.handleClick = this.handleClick.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleLogin = this.handleLogin.bind(this)
        this.expandir = this.expandir.bind(this)
    }

    logout() {
        window.localStorage.setItem("rotaAtual", "");
        this.props.history.push('/');
    }

    verifyUser = async () => {
        const usuarioStorage = window.localStorage.getItem('user')
        const res = await API.get('/api/usuarios/current_user')
        const { _id, perfil, isApp } = res.data

        if(isApp === true && (perfil == 'CAMBISTA' || perfil == 'CLIENTE')){
            window.localStorage.removeItem('user')
            window.location.href = "https://www.cartelas.app"
        }
        else if (_id && usuarioStorage) {
            redirectUser(res.data.perfil)
        } else {
            window.localStorage.removeItem('user')
        }
    }

    componentDidMount() {
        window.document.getElementById('noticia').click()
        this.verifyUser();
    }

    async getBanner() {
        try {
            var axiosInstance = new Axios.create({baseURL: window.localStorage.getItem("apiUrl")});
            const response = await axiosInstance.get("parametros/get-banner");
            this.setState({banner: response.data.banner});
            localStorage.setItem('banner', JSON.stringify(response.data.banner))
            localStorage.setItem('updateHour', new Date().getHours())
        } catch (err) {
            console.log(err);
        }
    }

    async getSAC() {
        try {
            var axiosInstance = new Axios.create({baseURL: window.localStorage.getItem("apiUrl")});
            const response = await axiosInstance.get("parametros/get-sac");
            this.setState({sac: response.data.contatoSAC});
        } catch (err) {
            console.log(err);
        }
    }


    handleClick(event) {
        this.handleLogin(event)
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value })
    }

    async getParametros() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("parametros/", {});
            this.setState({ parametros: response.data })
        } catch (err) {
            console.log(err);
        }
    }

    async handleLogin(e) {
        e.preventDefault()
        const { email, senha } = this.state

        if (email && senha) {
            this.setState({ loggingIn: true })
            try {
                const result = await API.post('/api/user/login', {email});
                const response = await API.post('/api/auth/login', {
                    email,
                    senha,
                })
                const { errors, isApp , perfil} = response.data
                if (errors) {
                    this.setState({ loggingIn: false, open: true, snackMessage: errors })
                } 
                
                else if(isApp === true && (perfil == 'CAMBISTA' || perfil == 'CLIENTE')){
                    window.localStorage.removeItem('user')
                    window.location.href = "https://www.cartelas.app"
                }
                
                else {
                    this.setState({ auth: response.data })
                    window.localStorage.setItem('user', JSON.stringify(response.data))
                    // redirectUser(this.state.auth.perfil)
                    // this.props.history.push('/Configuracoes')


                    switch (this.state.auth.perfil) {
                        case 'CLIENTE':
                            this.props.history.push('/loja-cliente')
                            break
                        case 'CAMBISTA':
                            this.props.history.push('/perfil-cambista')
                            break
                        case 'GERENTE':
                            this.props.history.push('/gerente-bilhetes')
                            break
                        case 'SUBMASTER':
                            this.props.history.push('/monitoria-recebidos')
                            break;
                        case 'ADMIN':
                                this.props.history.push('/admin-gerenciar-gerentes')
                                break
                        case 'MASTER':
                            this.props.history.push('/master-ganhadores')
                            break;
                    }
                }
            } catch (err) {
                console.log(err)
                this.setState({ loggingIn: false })
            }
        } else {
            this.setState({ loggingIn: false, open: true, severity: 'danger', snackMessage: 'Preencha os campos com seu email e senha' })
        }
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ open: false })
    }

    expandir(event) {
        this.setState({
            toggleExpand: !this.state.toggleExpand
        });
    }

    render() {
        return (
            <div className="documentation" >


                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    key={'top,right'}
                    style={{ top: '60', minWidth: 420, maxWidth: 600 }}
                    autoHideDuration={2800}
                    open={this.state.open}
                    onClose={this.handleClose}
                >
                    <div className={`alert alert-${this.state.severity} py-3 w-100 col`} role="alert">
                        {this.state.snackMessage}
                        <button type="button" onClick={this.handleClose} className="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </Snackbar>

                <div class="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered"
                        style={
                            {marginTop: '-4em'}
                        }
                        role="document">
                        <div class="modal-content "
                            style={
                                {
                                    backgroundColor: 'transparent',
                                    border: 'none'
                                }
                        }>
                            <div class="modal-header"
                                style={
                                    {
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        paddingRight: '2em'
                                    }
                            }>
                                <button type="button" class="btn-fill btn btn-danger close"
                                    style={
                                        {
                                            width: '1em',
                                            fontSize: '3em',
                                            color: 'white'
                                        }
                                    }
                                    data-dismiss="modal"
                                    aria-label="Close">
                                    <span aria-hidden="false">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body"
                                style={
                                    {
                                        display: 'flex',
                                        justifyContent: 'center'
                                    }
                            }>
                                <img className="banner"
                                    src={
                                        this.state.banner
                                }></img>
                            </div>
                            <div class="modal-footer"
                                style={
                                    {justifyContent: 'flex-end'}
                            }></div>
                        </div>
                    </div>
                </div>


                <div class="modal fade" id="exampleModalCenter2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '50vw', marginTop: '-8em' }} role="document">
                        <div class="modal-content "  >
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body" style={{ display: 'flex', justifyContent: 'center' }}>
                                <iframe width="1024" height="512" src="https://www.youtube.com/embed/XpQCyDCfXYY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="wrapper">
                    <div class="page-header clear-filter" filter-color="purple">
                        <div
                            class="page-header-image"
                            data-parallax="true"
                            style={{backgroundImage: `url(${background})`}}
                            >
                            <div className="title-container text-center">
                                <div className="container" style={{ marginTop: '-5em' }}>
                                    <div className="d-flex justify-content-center h-100">
                                        <div
                                            className="card"
                                            style={{
                                                width: '27em',
                                                backgroundColor: 'rgba(0,0,0,0.2)',
                                            }}
                                        >
                                            <div
                                                className="card-header"
                                                style={{
                                                    backgroundColor: 'rgba(0,0,0,0.1)',
                                                }}
                                            >
                                                <h3>Entrar</h3>
                                            </div>
                                            <div className="card-body">
                                                <form onSubmit={this.handleLogin}>
                                                    <div className="input-group form-group">
                                                        <input
                                                            onChange={this.handleChange}
                                                            type="text"
                                                            name="email"
                                                            className="form-control"
                                                            placeholder="Email ou DDD + telefone"
                                                        />
                                                    </div>
                                                    <div className="input-group form-group">
                                                        <input
                                                            onChange={this.handleChange}
                                                            name="senha"
                                                            type="password"
                                                            className="form-control"
                                                            placeholder="Senha"
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            disabled={this.state.loggingIn}
                                                            type="submit"
                                                            value="Login"
                                                            className="btn float-right login_btn"
                                                        />
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="card-footer">
                                                <div className="d-flex justify-content-center links">
                                                    Não tem uma conta?<Link to="/registrar">Cadastre-se</Link>
                                                </div>
                                                <div className="d-flex justify-content-center"  id="noticia" data-toggle="modal" data-target="#exampleModalCenter" >
                                                    <Link to="recuperar-senha">Esqueceu a senha?</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className='my-nav-bar'>
                                    <a target="_blank" style={{backgroundColor: '#2dd195'}}  href="https://www.sorteflash.com/download/sorteflash-app.apk" ><i class="fa fa-android"></i>_Aplicativo</a>
                                    <button onClick={() => window.location.href = "/geral-ganhadores"} style={{backgroundColor: '#1d77f3'}}><i class="fas fa-trophy"></i> Ganhadores</button>
                                    <button onClick={() => window.location.href = 'https://www.youtube.com/c/SORTEFLASH'} style={{backgroundColor: '#f31d7c'}}><i class="fab fa-youtube"></i> Youtube</button>
                                    <button onClick={() => window.location.href = "/regulamento"}>Regulamento</button>
                                    <button onClick={() => window.location.href = 'https://wa.me/55'+this.state.sac} >Contato</button>
                                    <button data-toggle="modal" data-target="#exampleModalCenter2" style={{backgroundColor: '#1debf3'}}><i class="fas fa-bell"></i> Noticias</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer className="footer">
                        <div className="container-fluid">
                            <nav>
                                <ul className="footer-menu">
                                    <li>
                                        <Link to="https://www.sorteflash.com/download/sorteflash-app.apk">Empresa</Link>
                                    </li>
                                    <li>
                                        <Link to="/regulamento">Regulamento</Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.sorteflash.com/download/sorteflash-app.apk">Outros projetos</Link>
                                    </li>
                                </ul>
                                <p className="copyright text-center">
                                    Proprietário ©
                                    <Link to="https://www.instagram.com/sorteflash/">SorteFlash</Link>
                                </p>
                            </nav>
                        </div>
                    </footer>
                </div>
            </div>
        )
    }
}

export default Login
